import Resource from '../../../api/resource';
import request from '../../../utils/request';


class Service extends Resource {
    constructor() {
        super('services');
    }
    services(payload){
        return request({
            url: "services/index",
            method: "post",
            data: payload
        });
    } 
    
    requests(payload){
        return request({
            url : "services/requests",
            method: "post",
            data:payload
        })
    }
    
    getRequest(id){
        return request({
            url : `services/request/${id}` ,
            method :"get"
        })
    }

    create(payload){
        return request({
            url : 'services/create',
            method: "post",
            data : payload
        })
    }

    delete(payload){
        return request({
            url : `services/request/${payload.id}`,
            method : 'delete'
        })
    }

    

}


export {Service as default};